import { Injectable } from '@angular/core';
import { Apollo, QueryRef } from 'apollo-angular';
import { Observable } from 'rxjs';
import { ErrorsInterface } from '../errors/errors-interface';
import { TaskFileGroupInterface } from './definitions/task-file-group-interface';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

interface TaskFileGroupByIdResponse {
  taskFileGroup: {
    byId: {
      output: TaskFileGroupInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class TaskFileGroupByIdService {
  constructor(private apollo: Apollo) {}

  get(
    taskFileGroupId: string,
    query: DocumentNode
  ): QueryRef<TaskFileGroupByIdResponse> {
    return this.apollo.watchQuery<TaskFileGroupByIdResponse>({
      query: query,
      variables: {
        id: taskFileGroupId,
      },
      fetchPolicy: 'network-only',
    });
  }
}
